<template>
  <div class="NewsDetails">
    <banner img="@/assets/img/bgtop.jpg" />
    <div class="NewsDetails-product">
      <div class="NewsDetails-product-content">
        <img :src="newsIdList.Img" alt />
        <p class="product-title">{{ newsIdList.Title }}</p>
        <p class="product-time">{{ newsIdList.CreateTime }}</p>
        <p class="product-content">{{ newsIdList.Content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
export default {
  name: "NewsDetails",
  components: {
    Banner,
  },
  data() {
    return {
      pid: 0,
      newsIdList: {},
      List: [
        {
          Id: "1",
          Title: "老年人轮椅",
          Img: require("@/assets/img/QiXie1.png"),
          CreateTime: "2024-04-16 17:51",
          Content:
            "轮椅是装有轮子可以帮助替代行走的椅子，是用于伤员、病员、残疾人居家康复、周转运输、就诊、外出活动的重要移动工具。轮椅不仅满足肢体伤残者和行动不便人士的代步需求，更重要的是方便家属移动和照顾病员，使病员借助于轮椅进行身体锻炼和参与社会活动。",
        },
        {
          Id: "2",
          Title: "血糖仪",
          Img: require("@/assets/img/QiXie2.png"),
          CreateTime: "2024-04-22 18:05",
          Content:
            "血糖仪又称血糖计，是一种测量血糖水平的电子仪器。血糖仪从工作原理上分为光电型和电极型两种。电极型血糖仪的测试原理更科学，电极可内藏。",
        },
        {
          Id: "3",
          Title: "血压仪",
          Img: require("@/assets/img/QiXie3.png"),
          CreateTime: " 2024-06-07 15:44",
          Content:
            "血压仪是测量血压的仪器，也叫血压计。按测量血压的设计原理来区分主要有听诊法血压计和示波法血压计。听诊法也叫柯氏音法，是临床医学无创血压测量的金标准。 听诊方式可分为人工听诊法和自动听诊法。水银血压计(压力计)、弹簧表式血压计(压力表)就是早期的人工听诊法血压计，人工听诊法有数显血压计、光柱血压计、光显血压计、液晶血压计等;听诊法自动化的技术难度大。柯氏听诊法自动化将会是血压计发展的主要方向。自动听诊法血压计会让血压测量更方便更精准。示波法又叫振荡法，简单说就是获取在放气过程中产生的振荡波，通过一定的算法换算得出血压值。绝大多数的电子血压计均是采用示波原理来设计的。电子血压计有上臂式、手腕式、指式之分。",
        },
      ],
    };
  },
  created() {
    this.pid = this.$route.params.id;
    window.console.log(this.pid);
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.List.forEach((item) => {
        if (item.Id == this.pid) {
          this.newsIdList = item;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.NewsDetails {
  width: 100%;
  height: 100%;
  //overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        //height: 500px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>